export default "__VITE_ASSET__DFBX_ZOb__"